module.exports = __webpack_public_path__ + "img/meng-shi-icon.e865d070.png";